// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import "@/polyfills";
// Notifications plugin. Used on Notifications page
import Notifications from "@/components/NotificationPlugin";
// Validation plugin used to validate forms
import { configure } from "vee-validate";
// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "@/components/SidebarPlugin";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

// vue-bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// asset imports
import "@/assets/scss/argon.scss";
import "@/assets/vendor/nucleo/css/nucleo.css";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/en.json";

const customRuleMessages = {
  required: "กรุณากรอกข้อมูลให้ครบถ้วน",
  numeric: "กรุณาใส่ข้อมูลเป็นตัวเลข",
  email: "กรุณากรอกอีเมลให้ถูกต้อง"
  // เพิ่มกฏอื่นๆ และ custom messages ที่นี่
};
Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: customRuleMessages[rule] || messages[rule], // assign message
  });
});

extend("firstRateStartZero", {
  validate(value, { rates, isFirst }) {
    if (!isFirst) return true; // Rule only applies to the first item
    return rates && rates.length > 0 && rates[0].start == 0;
  },
  params: ["rates", "isFirst"],
  message: "ค่าแรกต้องเป็น 0 เท่านั้น",
});

// Rule for rate.end to be greater than rate.start
extend("rateEndGreaterThanStart", {
  validate(value, { start }) {
    return value > start;
  },
  params: ["start"],
  message: "End value must be greater than start value",
});

// Rule for the next rate.start to be greater than the previous rate.end
extend("subsequentRateStartGreaterThanPreviousEnd", {
  validate(value, { rates, index }) {
    if (index === 0) return true; // skip the first item
    return +value == +rates[index - 1].end + 1;
  },
  params: ["rates", "index"],
  message: "ระยะทางสามารถมากกว่าก่อนหน้าแค่ 1 เท่านั้น",
});
export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    configure({
      classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
      },
    });
  },
};
